import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Chip } from 'components/ui';
import InspectionStatus from 'utils/inspection_state';

const State = ({ status = {} }) => {
  return (
    <Chip
      variant="outlined"
      size="small"
      color={InspectionStatus(status).color}
      label={<FormattedMessage id={`inspection.status.${status}`} />}
    />
  );
};

export default State;
